
angular.module('mean.projects').controller('ProjectContractorController', ['$scope', '$rootScope', '$http', 'Global', 'MeanUser', 'Users', '$filter', 'Projects', 'ProjectTasks', '$timeout', 'ProjectBids', 'Builders', 'Contractors', 'ProjectHours', 'ProjectMaterials', 'ProjectEquipments', 'userService', 'Trades', 'builderService', 'contactService', 'tradeCodeService', 'aceUtils', 'toaster', 'ngDialog', 'Options', 'Extras', 'foremanPhaseService', 'foremanAdjustCombinedQuantitiesService', 'costTotalService', 'projectOptionService', 'projectBidService', 'NgTableParams',
  function($scope, $rootScope, $http, Global, MeanUser, Users, $filter, Projects, ProjectTasks, $timeout, ProjectBids, Builders, Contractors, ProjectHours, ProjectMaterials, ProjectEquipments, userService, Trades, builderService, contactService, tradeCodeService, aceUtils, toaster, ngDialog, Options, Extras, foremanPhaseService, foremanAdjustCombinedQuantitiesService, costTotalService, projectOptionService, projectBidService, NgTableParams) {
    $scope.global = Global;

    $scope.package = {
      name: 'projectContractor'
    };

    $scope.database_view = false;

    $scope.is_admin = false;
    $scope.is_manager = false;
    $scope.codes = [];
    $scope.open_contract_details = false;
    $scope.open_options_details = false;
    $scope.open_extras_details = false;
    $scope.bid_revisions = 1;

    $scope.summaryTable = {};
    $scope.costDetails = {};
    $scope.factors = {};
    $scope.all_bid_tasks = [];

    Chart.defaults.global.responsive = true;

    Chart.defaults.global.scaleLabel = function (label) {
        if($scope.selectedGraph === 'Labor Hours') {
            return label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return '$ ' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    };

    Chart.defaults.global.multiTooltipTemplate = function (label) {
        var tmp = $filter('filter')($scope.codes, {'name': label.label}, true)[0];
        if(tmp)
          label.label = label.label + ' ' + tmp.task_name;
        if($scope.selectedGraph === 'Labor Hours') {
            return label.datasetLabel + ': ' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return label.datasetLabel + ': $ ' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    };

    $scope.spreadsheets = [];
    $scope.spreadsheets.phases = [];
    $scope.spreadsheets.phases.lots = [];
    $scope.spreadsheets.phases.lots.data = [];

    $scope.colors = ['#97BBCD','#46BFBD','#7FFD1F','#68F000'];

    $scope.bid_hours_labels = ["Total Hours", "Not Complete", "Delayed", "Completed", "No Valid Project or Tasks"];
  	$scope.bid_hours_data = [];
  	$scope.line_chart_labels = [];
  	$scope.line_chart_series = [];
  	$scope.line_chart_data = [
    	[],
    	[]
  	];

  	$scope.onClick = function (points, evt) {
    	console.log(points, evt);
  	};

    $scope.setShowContractDetails =  function(val) {
        $scope.open_contract_details = val;
    };

    $scope.toggleShowContractDetails =  function() {
        $scope.open_contract_details = !$scope.open_contract_details;
    };

    $scope.setShowOptionsDetails =  function(val) {
        $scope.open_options_details = val;
    };

    $scope.setShowExtrasDetails =  function(val) {
        $scope.open_extras_details = val;
    };

  	$scope.graphs = ['Labor Hours', 'Labor Costs', 'Total Costs', 'Materials', 'Equipment'];
    $scope.dataType = ['Cumulative', 'Task'];
  	$scope.selectedGraph = 'Labor Hours';
  	$scope.selectedItem = {};
    $scope.selectedDataType = 'Cumulative';
    $scope.tasks = [];
    $scope.builders = [];
    $scope.projects = [];
    $scope.phases = [];
    $scope.job_summary_phases = [];
    $scope.contract_complete_list = [];
    $scope.cost_details_list = [];
    $scope.lots = [];
    $scope.trades = [];
    $scope.user = MeanUser.user;
    $scope.wait = true;

    $rootScope.$on('loggedin', function() {
        $scope.user = MeanUser.user;
        $scope.init();
    });

    $scope.buildSummaryTable = function() {
        //if(!$scope.selectedPhase) return;

        $scope.summaryTable.bid_total = 0;
        $scope.summaryTable.bid_labor = 0;
        $scope.summaryTable.bid_direct_labor = 0;
        $scope.summaryTable.bid_hours_allowed = 0;
        $scope.summaryTable.bid_materials = 0;
        $scope.summaryTable.bid_equipment = 0;
        $scope.summaryTable.actual_total = 0;
        $scope.summaryTable.actual_labor = 0;
        $scope.summaryTable.actual_direct_labor = 0;
        $scope.summaryTable.actual_hours_allowed = 0;
        $scope.summaryTable.actual_materials = 0;
        $scope.summaryTable.actual_equipment = 0;
        $scope.summaryTable.diff_total = 0;
        $scope.summaryTable.diff_labor = 0;
        $scope.summaryTable.diff_direct_labor = 0;
        $scope.summaryTable.diff_hours_allowed = 0;
        $scope.summaryTable.diff_materials = 0;
        $scope.summaryTable.diff_equipment = 0;
        $scope.summaryTable.actual_payroll_taxes = 0;
        $scope.summaryTable.actual_workers_comp = 0;
        $scope.summaryTable.bid_payroll_taxes = 0;
        $scope.summaryTable.bid_workers_comp = 0;
        $scope.summaryTable.diff_payroll_taxes = 0;
        $scope.summaryTable.diff_workers_comp = 0;
        $scope.summaryTable.bid_general_liability = 0;
        $scope.summaryTable.actual_general_liability = 0;
        $scope.summaryTable.diff_general_liability = 0;

        var phases = [];
        var lots = [];

        //this is going to die a horrible death when more than one trade
        if($scope.selectedPhase.name !== 'All')
          phases = $filter('filter')($scope.spreadsheets.phases, {'name': $scope.selectedPhase.name}, true);
        else
          phases = $scope.spreadsheets.phases;

        //phases.forEach(function(item) {
        _.each(phases, function(item) {
            if($scope.selectedLot.name !== 'All')
              lots = $filter('filter')(item.lots, {'name': $scope.selectedLot.name}, true);
            else
              lots = item.lots;

            //lots.forEach(function(lot) {
             _.each(lots, function(lot) {
                //lot.data.forEach(function(task) {
                var bid_material_total = 0;
                var bid_equipment_total = 0;
                 _.each(lot.data, function(task) {
                    //need to make sure we're adding tasks based on the
                    //users trade selection
                    if($scope.selectedTrade.name === 'All' ||
                        $scope.selectedTrade.name === task.trade) {
                        console.log('allowing trade ' + task.trade);
                        var extra_labor = 0;
                        var extra_material = 0;
                        var extra_hours = 0;
                        var extra_equipment = 0;

                        var extras = $filter('filter')($scope.extras, {
                            'lot': task.lot, 'phase': task.phase,
                            'task': task.task_code }, true);

                        _.each(extras, function(each) {
                            extra_labor += each.labor;
                            extra_material += each.material;
                            extra_hours += each.hours;
                            extra_equipment += each.equipment;
                        });
                        var bid_material_cost = 0;
                        _.each(task.bid_materials, function(material) {
                            var sub_tot = material.price_per_order * material.quantity;
                            var cost = sub_tot +
                                (sub_tot * task.factors.sales_tax) +
                                (material.delivery_price * material.quantity);

                            bid_material_cost += cost;

                            // only include bid material costs for completed tasks
                            //if(task.status === 'finished') {
                                $scope.summaryTable.bid_materials += cost;
                            //}
                        });

                        task.bid_material_cost = bid_material_cost + extra_material;

                        bid_material_total += task.bid_material_cost;

                        _.each(task.materials, function(material) {
                            if(material.submitted) {
                                $scope.summaryTable.actual_materials += material.total;
                            }
                        });

                        var bid_equipment_cost = 0;
                        _.each(task.bid_equipment, function(equipment) {
                            var sub_tot = equipment.price_per_order * equipment.quantity;
                            var cost = sub_tot + 
                                (sub_tot * task.factors.equipment) +
                                (equipment.delivery_price * equipment.quantity);

                            bid_equipment_cost += cost;

                            //if(task.status === 'finished') {
                                $scope.summaryTable.bid_equipment += bid_equipment_cost;
                            //}
                        });
                        task.bid_equipment_cost = bid_equipment_cost + extra_equipment;

                        bid_equipment_total += task.bid_equipment_cost;

                        _.each(task.equipment, function(equipment) {
                            if(equipment.submitted) {
                                $scope.summaryTable.actual_equipment += equipment.total;
                            }
                        });

                        var bid_hours_allowed = task.hours_allowed + extra_hours;
                        var act_labor = task.actual_direct_labor + task.actual_workers_comp;
                        task.actual_total = task.actual_labor_costs+task.actual_material_costs
                            +task.actual_equipment_costs;
                        //compute bid side labor costs
                        var bid_work_comp = 0;
                        if(task.labor_cost/bid_hours_allowed < task.factors.w_comp_break)
                          bid_work_comp = task.labor_cost * task.factors.w_comp_high;
                        else
                          bid_work_comp = task.labor_cost * task.factors.w_comp_low;

                        var labor = task.labor_cost + bid_work_comp;

                        task.bid_labor_cost = labor + task.labor_cost * task.factors.payroll_taxes;
                        task.bid_total = task.bid_labor_cost+task.bid_material_cost
                            +task.bid_equipment_cost;
                        //lot.completed says that the task is completed
                        if(task.completed) {
                            $scope.summaryTable.bid_materials += extra_material;
                            $scope.summaryTable.bid_equipment += extra_equipment;
                            $scope.summaryTable.bid_hours_allowed += bid_hours_allowed;
                            $scope.summaryTable.bid_direct_labor += task.labor_cost;
                            $scope.summaryTable.actual_hours_allowed += task.actual_man_hours;
                            $scope.summaryTable.actual_direct_labor += task.actual_direct_labor;

                            $scope.summaryTable.actual_payroll_taxes += 
                                task.actual_direct_labor * task.factors.payroll_taxes;

                            $scope.summaryTable.actual_workers_comp += task.actual_workers_comp;

                            $scope.summaryTable.actual_labor += 
                                act_labor + task.actual_direct_labor * task.factors.payroll_taxes;

                            $scope.summaryTable.bid_payroll_taxes += 
                                task.labor_cost * task.factors.payroll_taxes;

                            $scope.summaryTable.bid_workers_comp += bid_work_comp;

                            $scope.summaryTable.bid_labor += task.bid_labor_cost + extra_labor;
                        }
                    }
                });

                lot.bid_material_total = bid_material_total;
                lot.bid_equipment_total = bid_equipment_total;
            });
        });

        $scope.summaryTable.diff_hours_allowed = $scope.summaryTable.bid_hours_allowed -
            $scope.summaryTable.actual_hours_allowed;

        $scope.summaryTable.actual_total = $scope.summaryTable.actual_labor +
            $scope.summaryTable.actual_materials + $scope.summaryTable.actual_equipment;
        $scope.summaryTable.bid_total = $scope.summaryTable.bid_labor +
            $scope.summaryTable.bid_materials + $scope.summaryTable.bid_equipment;

        $scope.summaryTable.diff_direct_labor = $scope.summaryTable.bid_direct_labor - 
            $scope.summaryTable.actual_direct_labor;

        $scope.summaryTable.diff_general_liability = $scope.summaryTable.bid_general_liability - 
            $scope.summaryTable.actual_general_liability

        $scope.summaryTable.diff_materials = $scope.summaryTable.bid_materials -
                $scope.summaryTable.actual_materials;
        $scope.summaryTable.diff_equipment = $scope.summaryTable.bid_equipment -
                $scope.summaryTable.actual_equipment;

        $scope.summaryTable.diff_payroll_taxes = $scope.summaryTable.bid_payroll_taxes - 
            $scope.summaryTable.actual_payroll_taxes;
        $scope.summaryTable.diff_workers_comp = $scope.summaryTable.bid_workers_comp - 
            $scope.summaryTable.actual_workers_comp;

        $scope.summaryTable.diff_total = $scope.summaryTable.bid_total - $scope.summaryTable.actual_total;
        $scope.summaryTable.diff_labor = $scope.summaryTable.bid_labor - $scope.summaryTable.actual_labor;

        $scope.summaryTable.diff_labor_percentage =
                $scope.summaryTable.diff_labor / $scope.summaryTable.bid_labor;
        $scope.summaryTable.diff_direct_labor_percentage =
                $scope.summaryTable.diff_direct_labor / $scope.summaryTable.bid_direct_labor;
        $scope.summaryTable.diff_hours_percentage = 
            ($scope.summaryTable.bid_direct_labor / $scope.summaryTable.bid_hours_allowed) -
                ($scope.summaryTable.actual_direct_labor / $scope.summaryTable.actual_hours_allowed);
        $scope.summaryTable.diff_payroll_percentage =
                $scope.summaryTable.diff_payroll_taxes / $scope.summaryTable.bid_payroll_taxes;
        $scope.summaryTable.diff_workers_percentage =
                $scope.summaryTable.diff_workers_comp / $scope.summaryTable.bid_workers_comp;
        $scope.summaryTable.diff_materials_percentage =
                $scope.summaryTable.diff_materials / $scope.summaryTable.bid_materials;
        $scope.summaryTable.diff_equipment_percentage =
                $scope.summaryTable.diff_equipment / $scope.summaryTable.bid_equipment;
        // $scope.summaryTable.diff_labor_percentage =
        //         ($scope.summaryTable.bid_labor / $scope.summaryTable.bid_total) -
        //         ($scope.summaryTable.actual_labor / $scope.summaryTable.actual_total);
        // $scope.summaryTable.diff_direct_labor_percentage =
        //         ($scope.summaryTable.bid_direct_labor / $scope.summaryTable.bid_total) -
        //         ($scope.summaryTable.actual_direct_labor / $scope.summaryTable.actual_total);
        // $scope.summaryTable.diff_hours_percentage = 
        //         ($scope.summaryTable.bid_direct_labor / $scope.summaryTable.bid_hours_allowed) -
        //         ($scope.summaryTable.actual_direct_labor / $scope.summaryTable.actual_hours_allowed);
        // $scope.summaryTable.diff_materials_percentage =
        //         ($scope.summaryTable.bid_materials / $scope.summaryTable.bid_total) -
        //         ($scope.summaryTable.actual_materials / $scope.summaryTable.actual_total);
        // $scope.summaryTable.diff_equipment_percentage =
        //         ($scope.summaryTable.bid_equipment / $scope.summaryTable.bid_total) -
        //         ($scope.summaryTable.actual_equipment / $scope.summaryTable.actual_total);
    };

    $scope.buildLineChart = function() {
        $scope.line_chart_labels = [];
        $scope.line_chart_data = [];
        var bid_data = [];
        var actual_data = [];
        var task_data = [];
        $scope.codes = [];
        var total_hours = 0;
        var total_bids = 0;

        if(!$scope.selectedPhase || !$scope.selectedItem) {
            $scope.line_chart_labels = ['Invalid Project'];
            $scope.line_chart_data = [ [0] , [0] ];

            return;
        }

        var my_bids = [];
        var my_tasks = [];

        if($scope.selectedTrade.name === 'All') {
            my_bids = $scope.all_bid_tasks;
            if($scope.selectedPhase.name === 'All') {
                my_tasks = $scope.tasks;
            } else {
                my_tasks = $filter('filter')($scope.tasks, {'phase': $scope.selectedPhase.name});
            }
            if($scope.selectedLot.name !== 'All') {
                my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
            }
        } else {
            my_bids = $filter('filter')($scope.all_bid_tasks, {'trade': $scope.selectedTrade.name});

            if($scope.selectedPhase.name === 'All') {
                my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name});
            } else {
                my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name, 'phase': $scope.selectedPhase.name});
            }

            if($scope.selectedLot.name !== 'All') {
                my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
            }
        }

        my_tasks = $filter('orderBy')(my_tasks, ['task_code'], false);
        
        _.each(my_tasks, function(task) {
            //only build the line chart for bid trades
            var is_tracked = $filter('filter')($scope.trades, {'name': task.trade}, true);
            if(is_tracked.length !== 0) {
                var in_var = $filter('filter')($scope.codes, {'name': task.task_code}, true);

                if(in_var.length === 0) {
                    $scope.codes.push({
                        name: task.task_code,
                        task_name: task.task_name
                    });
                }
            }
        });

        if($scope.selectedGraph === 'Labor Hours') {
            $scope.line_chart_series = ['Bid Hours', 'Actual Hours'];
            _.each($scope.codes, function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                _.each(tmp, function(add) {
                    var extra_hours = 0;
                    
                    var extras = $filter('filter')($scope.extras, {
                        'lot': add.lot, 'phase': add.phase,
                        'task': add.task_code }, true);

                    _.each(extras, function(each) {
                        extra_hours += each.hours;
                    });

                    //T&M tasks don't have bid data
                    if(add.plan_code === 'T&M') {
                        total_hours += add.actual_man_hours;
                    } else {
                        var bid = $filter('filter')(my_bids, {'task_code': code.name, 
                            'plan_code': add.plan_code,
                            'lot': add.lot,
                            'phase': add.phase }, true);

                        if(bid.length !== 1) {
                            var revisions = $filter('filter')(my_bids, {
                                'latest': false,
                                'lot': add.lot,
                                'phase': add.phase,
                                'task_code': add.task_code,
                                'plan_code': add.plan_code }, true);

                            if(revisions.length > 0) {
                                toaster.pop('error', 'Task/Bid Error', 'There is a problem with ' +
                                    add.phase + '/' + add.lot + 
                                    ' go to project information and reset the revision for this lot.');
                                return;
                            } else {
                                var bid_revision = $filter('filter')(my_bids, {
                                    'task_code': add.task_code,
                                    'lot': add.lot,
                                    'phase': add.phase,
                                    'plan_code': add.plan_code }, true);

                                if(bid_revision.length === 1) {
                                    //project_bid_id has changed for this
                                    //task so update with new value
                                    add.project_bid_id = bid_revision[0]._id;
                                    add.$update(function(success) {
                                        toaster.pop('success', 'Project Task Update',
                                            'Was able to update ' + success.task_code +
                                            ', please reload page');
                                    }, function(error) {
                                        toaster.pop('error', 'Project Task Update',
                                            error);
                                        return;
                                    });
                                } else {
                                    toaster.pop('error', 'Task/Bid Error', 
                                        'There is a problem with ' + add.phase + '/' + add.lot + 
                                        ' go to project information and reset the revision for this lot.');
                                    return;
                                }
                            }
                        } else {
                            total_bids += bid[0].totals.hours_allowed + extra_hours;
                            total_hours += add.actual_man_hours;
                        }
                    }
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else if ($scope.selectedGraph === 'Labor Costs') {
            $scope.line_chart_series = ['Bid Labor Costs', 'Actual Labor Costs'];
            _.each($scope.codes, function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                _.each(tmp, function(add) {
                    var extra_labor = 0;

                    var extras = $filter('filter')($scope.extras, {
                        'lot': add.lot, 'phase': add.phase,
                        'task': add.task_code }, true);

                    _.each(extras, function(each) {
                        extra_labor += each.labor;
                    });

                    var t_m = (add.plan_code === 'T&M')?true:false;

                    var bid = projectBidService.getProjectBidForTask(
                        add, my_bids, $scope.selectedItem.lots, $scope.bid_revisions);

                    if(bid.length !== 1 && !t_m) {
                        toaster.pop('error', 'projectContractor, Line: 334', 
                            'There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }

                    var phase = $filter('filter')($scope.spreadsheets.phases, {
                        'name': add.phase}, true)[0];

                    var lot = $filter('filter')(phase.lots, {
                        'name': add.lot}, true)[0];

                    var task = $filter('filter')(lot.data, {
                        'task_code': add.task_code}, true)[0];

                    var bid_labor = (t_m) ? 0 : bid[0].totals.labor;
                    total_bids += bid_labor + extra_labor;
                    total_hours += task.actual_labor_costs;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else if ($scope.selectedGraph === 'Total Costs') {
            $scope.line_chart_series = ['Bid Total Costs', 'Actual Total Costs'];
            //$scope.codes.forEach(function(code) {
            _.each($scope.codes, function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }
                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                //tmp.forEach(function(add) {
                _.each(tmp, function(add) {
                    if(!add.actual_equipment_costs) add.actual_equipment_costs = 0;

                    var extra_labor = 0;
                    var extra_material = 0;
                    //var extra_hours = 0;
                    var extra_equipment = 0;

                    var extras = $filter('filter')($scope.extras, {
                        'lot': add.lot, 'phase': add.phase,
                        'task': add.task_code }, true);

                    _.each(extras, function(each) {
                        extra_labor += each.labor;
                        extra_material += each.material;
                        //extra_hours += each.hours;
                        extra_equipment += each.equipment;
                    });

                    var t_m = (add.plan_code === 'T&M')?true:false;
                    var bid = projectBidService.getProjectBidForTask(
                        add, my_bids, $scope.selectedItem.lots, $scope.bid_revisions);
                    if(bid.length !== 1 && !t_m) {
                        toaster.pop('error', 'projectContractor, Line: 334', 
                            'There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }

                    var phase = $filter('filter')($scope.spreadsheets.phases, {
                        'name': add.phase}, true)[0];

                    var lot = $filter('filter')(phase.lots, {
                        'name': add.lot}, true)[0];

                    var task = $filter('filter')(lot.data, {
                        'task_code': add.task_code}, true)[0];

                    //subtrack out overhead costs from the bid_total
                    //if(task.status === 'finished') {
                        var bid_total = 0;
                        if(!t_m) {
                            bid_total = bid[0].totals.labor + task.bid_material_cost + 
                                bid[0].totals.equipment + bid[0].totals.general_liability;
                        }
                        total_bids += bid_total + extra_labor + extra_equipment;
                        //make sure actual_total already includes material and equipment
                        //total_hours += task.actual_total?task.actual_total:0;
                        //if(task.actual_total) {
                        var act_total = task.actual_total?task.actual_total:0
                        total_hours += act_total + add.computed_general_liability;
                        //} 
                    //} else {
                    //    total_bids += 0;
                    //    total_hours += 0;
                   // }
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else if ($scope.selectedGraph === 'Equipment') {
            $scope.line_chart_series = ['Bid Equipment Costs', 'Actual Equipment Costs'];
            //$scope.codes.forEach(function(code) {
            _.each($scope.codes, function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                //tmp.forEach(function(add) {
                _.each(tmp, function(add) {
                    if(!add.actual_equipment_costs) add.actual_equipment_costs = 0;

                    //var extra_labor = 0;
                    //var extra_material = 0;
                    //var extra_hours = 0;
                    var extra_equipment = 0;

                    var extras = $filter('filter')($scope.extras, {
                        'lot': add.lot, 'phase': add.phase,
                        'task': add.task_code }, true);

                    _.each(extras, function(each) {
                        //extra_labor += each.labor;
                        //extra_material += each.material;
                        //extra_hours += each.hours;
                        extra_equipment += each.equipment;
                    });

                    var t_m = (add.plan_code === 'T&M')?true:false;

                    var bid = projectBidService.getProjectBidForTask(
                        add, my_bids, $scope.selectedItem.lots, $scope.bid_revisions);

                    if(bid.length !== 1 && !t_m) {
                        toaster.pop('error', 'projectContractor, Line: 334', 
                            'There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }
                    var total_eq = (t_m) ? 0 : bid[0].totals.equipment;
                    total_bids += total_eq + extra_equipment;
                    total_hours += add.actual_equipment_costs;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else {
            $scope.line_chart_series = ['Bid Material Costs', 'Actual Material Costs'];
            //$scope.codes.forEach(function(code) {
            _.each($scope.codes, function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                //tmp.forEach(function(add) {
                _.each(tmp, function(add) {
                    //var extra_labor = 0;
                    var extra_material = 0;
                    //var extra_hours = 0;
                    //var extra_equipment = 0;

                    var extras = $filter('filter')($scope.extras, {
                        'lot': add.lot, 'phase': add.phase,
                        'task': add.task_code }, true);

                    _.each(extras, function(each) {
                        //extra_labor += each.labor;
                        extra_material += each.material;
                        //extra_hours += each.hours;
                        //extra_equipment += each.equipment;
                    });

                    var t_m = (add.plan_code === 'T&M')?true:false;

                    var bid = projectBidService.getProjectBidForTask(
                        add, my_bids, $scope.selectedItem.lots, $scope.bid_revisions);

                    if(bid.length !== 1 && !t_m) {
                        toaster.pop('error', 'projectContractor, Line: 334', 
                            'There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }

                    var phase = $filter('filter')($scope.spreadsheets.phases, {
                        'name': add.phase}, true)[0];

                    var lot = $filter('filter')(phase.lots, {
                        'name': add.lot}, true)[0];

                    var task = $filter('filter')(lot.data, {
                        'task_code': add.task_code}, true)[0];

                    //var total_mat = (t_m) ? 0 : bid[0].totals.materials;
                    var total_mat = (t_m) ? 0 : task.bid_material_cost;
                    total_bids += total_mat;
                    total_hours += task.actual_material_costs;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        }
    };

    $scope.buildDoughnutChart = function() {
        var total_hours_allowed = 0;
        var completed_hours = 0;
        //var actual_hours = 0;
        var not_completed_hours = 0;
        var delayed_hours = 0;

        var my_tasks = [];

        if($scope.selectedTrade.name === 'All') {
            if($scope.selectedPhase.name === 'All') {
                my_tasks = $scope.tasks;
            } else {
                my_tasks = $filter('filter')($scope.tasks, {'phase': $scope.selectedPhase.name});
            }
            if($scope.selectedLot.name !== 'All') {
                my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
            }
        } else {
            if($scope.selectedPhase.name === 'All') {
                my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name});
            } else {
                my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name, 'phase': $scope.selectedPhase.name});
            }

            if($scope.selectedLot.name !== 'All') {
                my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
            }
        }

        //right now the doughnut tracks by hours in the
        //bid and does not display actual.  Might want
        //to add this in the future.
        //my_tasks.forEach(function(task) {
        _.each(my_tasks, function(task) {
            //only build the doughnut chart for bid trades
            var is_tracked = $filter('filter')($scope.trades, {'name': task.trade}, true);
            if(is_tracked.length === 0) return;

            var bid = $filter('filter')($scope.all_bid_tasks, {
                'lot': task.lot,
                'phase': task.phase,
                'task_code': task.task_code, 
                'plan_code': task.plan_code}, true);

            for(var i=0; i<bid.length; i=i+1) {
                var bid_total_hours_allowed = angular.copy(bid[i].totals.hours_allowed);
                if(bid[i].has_options) {
                    var bid_subs = [];
                    _.each(bid[i].subtasks, function(sub) {
                        var bids = $filter('filter')(sub.multi_data, {
                            'phase': task.phase, 'lot': task.lot }, true);

                        var hours_allowed = angular.copy(sub.hours_allowed);

                        if(bids.length > 0) {
                            bid_total_hours_allowed -= hours_allowed;
                            hours_allowed *= bids[0].multiple;
                            bid_total_hours_allowed += hours_allowed;
                        }
                    })
                }
                total_hours_allowed += bid_total_hours_allowed;
                if(task.status === 'finished') {
                    completed_hours += bid_total_hours_allowed;
                    //actual_hours += task.actual_man_hours;
                } else if(task.status === 'on_track'){
                    not_completed_hours += bid_total_hours_allowed;
                } else {
                    delayed_hours += bid_total_hours_allowed;
                }
            }
        });

        total_hours_allowed = total_hours_allowed.toFixed(2);
        completed_hours = completed_hours.toFixed(2);
        not_completed_hours = not_completed_hours.toFixed(2);
        delayed_hours = delayed_hours.toFixed(2);
        //actual_hours = actual_hours.toFixed(2);

        $scope.bid_hours_data = [total_hours_allowed, not_completed_hours, delayed_hours, completed_hours, 0];
    };

    $scope.phaseFilter = function(selected) {
    	if(!selected) return;

    	if(selected.name === 'All') {
    		return function() {
    			return true;
    		};
    	} else {
    		return function(selectedPhase) {
	    		return selectedPhase.name === selected.name;
	    	};
    	}
    };

    $scope.lotFilter = function(selected) {
        if(!selected) return;

        if(selected.name === 'All') {
            return function() {
                return true;
            };
        } else {
            return function(selectedLot) {
                return selectedLot.name === selected.name;
            };
        }
    };

    // $scope.changeTrade = function() {
    //     if(!$scope.selectedTrade) return;

    //     if($scope.selectedTrade.name === 'All') {
    //         var my_tasks = $scope.tasks;
    //     } else {
    //         var my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name});
    //     }

    //     $scope.buildDoughnutChart();
    //     $scope.buildLineChart();
    //     $scope.buildSummaryTable();
    //     $scope.buildSpreadsheet();
    // };

    $scope.changePhase = function() {
    	if(!$scope.selectedPhase) return;

        $scope.lots = [];

    	if($scope.selectedPhase.name === 'All') {
	    	var my_tasks = $scope.tasks; //$filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
	    } else {
	    	var my_tasks = $filter('filter')($scope.tasks, {
                'phase': $scope.selectedPhase.name}, true);
	    }

        my_tasks.forEach(function(task) {
            var in_lot = $filter('filter')($scope.lots, { 'name': task.lot}, true);

            if(in_lot.length === 0) {
                $scope.lots.push({
                    name: task.lot
                });
            }
        });

        var data = $filter('filter')($scope.all_project_materials, {'phase': $scope.selectedPhase.name}, true);
        //console.log(JSON.stringify(data))
        $scope.tableListMaterialParams = new NgTableParams({ count: 50 }, { dataset: data });

        $scope.lots = $filter('orderBy')($scope.lots, ['name'], false);

        $scope.lots.unshift({
            name: 'All'
        });

        $scope.selectedLot = $scope.lots[0];

        $scope.buildDoughnutChart();
        $scope.buildLineChart();
        $scope.buildJobCostingTable();
        $scope.buildSummaryTable();
    };

    $scope.changeLot = function() {
        if(!$scope.selectedLot) return;

        if($scope.selectedLot.name === 'All') {
            var my_tasks = $scope.tasks; //$filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
        } else {
            var my_tasks = $filter('filter')($scope.tasks, {'lot': $scope.selectedLot.name});
        }

        $scope.buildDoughnutChart();
        $scope.buildLineChart();
        $scope.buildJobCostingTable();
        $scope.buildSummaryTable();
    };

    $scope.changeBuilder = function() {
        if(!$scope.selectedBuilder) return;
        $scope.projects = [];
        $scope.tasks = [];
        $scope.phases = [];
        $scope.job_summary_phases = [];
        $scope.lots = [];
        $scope.bid_tasks = [];
        $scope.trades = [];
        $scope.bid_hours_data = [0,0,0,0,1];

      userService.getMainAccount($scope.user.username).then(function(user) {
        if($scope.is_admin) {
            //var match_string = '{ "trades.main_username": ' + user.username + '}';
            // Simple GET request example:
            // $http({
            //     method: 'GET',
            //     url: 'http://localhost:3000/api/projects/names',
            //     params: {
            //         'company_code': $scope.selectedBuilder.company_code,
            //         'trade_code': $scope.selectedBuilder.trade_code,
            //         'complete': false,
            //     }
            // }).then(function successCallback(response) {
            //     // this callback will be called asynchronously
            //     // when the response is available
            //     $scope.projects = response.data;
            // }, function errorCallback(response) {
            //     // called asynchronously if an error occurs
            //     // or server returns response with an error status.
            //     console.log(response);
            //     toaster.pop('error', 'Getting Project Names Error', response);
            // });
          	Projects.query({
                  'company_code': $scope.selectedBuilder.company_code,
                  'trade_code': $scope.selectedBuilder.trade_code,
                  'type': 'NamesOnly',
                  'complete': false,
                  'username': user.username }
                  , function(projects) {
          		$scope.projects = projects;
          	});

        } else if($scope.is_manager) {
            Projects.query({
                'type': 'NameOnlyManagerProjects',
                'company_code': $scope.selectedBuilder.company_code,
                'trade_code': $scope.selectedBuilder.trade_code,
                'complete': false,
                'manager': MeanUser.user.username }
                  , function(projects) {
                $scope.projects = projects;
            });
        } else {
            toaster.pop('error', 'Role Not Handled', 'Call Brian');
            return;
        }
      });
    };

    // $scope.getOptionSubtask = function(lot, task, bid_task) {
    //     var all_subtasks = [];

    //     _.each(lot.active_options, function(opt) {
    //         var subtasks = [];
    //         var optTrade = $filter('filter')(opt.totals, {'trade': $scope.user.trade[0]}, true)[0];
    //         var lotRev = 1;
    //         //does our trade have an active option and what is our revision
    //         if(optTrade) {
    //             lotRev = optTrade.option_revision;

    //             var option = $filter('filter')($scope.trade_options.options, {'number': opt.number}, true)[0];

    //             if(option) {
    //                 subtasks = $filter('filter')(option.subtasks, {
    //                     'plan': task.plan_code, 'code': task.task_code, 'revision': lotRev }, true);
    //             } else {
    //                 console.log('problem with option ' + option.number);
    //             }
    //         }
    //         _.each(subtasks, function(sub) {
    //             all_subtasks.push(sub);
    //         });
    //     });

    //     return all_subtasks;
    // };

    $scope.applyBidTaskMultiple = function(bid, multiple) {
        console.log('apply bid multiple');
        var hours = 0;
        var current_net_pay = 0;
        var labor = 0;
        _.each(bid.subtasks, function(subtask) {
            if(subtask.is_option) {
                subtask.quantity *= multiple;
                subtask.current_net_pay *= multiple;
                subtask.hours_allowed *= multiple;
                subtask.labor_total *= multiple;
                subtask.material_total *= multiple;
                subtask.equipment_total *= multiple;
                subtask.is_multiple = true;
            }
            
            hours += subtask.hours_allowed;
            current_net_pay += subtask.current_net_pay;
            labor += subtask.labor_total;
        });

        bid.totals.hours_allowed += hours;
        bid.totals.current_net_pay += current_net_pay;
        bid.totals.labor += labor;

        _.each(bid.materials, function(mat) {
            if(mat.is_option) {
                mat.quantity *= multiple;
                mat.delivery_price *= multiple;
                mat.materials_subtotal *= multiple;
                mat.is_multiple = true;
            }
        });

        _.each(bid.equipment, function(mat) {
            if(mat.is_option) {
                mat.quantity *= multiple;
                mat.delivery_price *= multiple;
                mat.materials_subtotal *= multiple;
                mat.is_multiple = true;
            }
        });

        return bid;
    };

    $scope.playActiveOptionsOnBid = function(lot_info, bids, task) {
        if(lot_info.active_options.length === 0) return;

        var changes_made = false;
        var new_bid_tasks = [];
        var return_bid = [];

        var trades_array = $filter('filter')($scope.selectedItem.trades, {
            'name': $scope.my_trade.trade }, true);

        var lotRevision = $filter('filter')(trades_array[0].revisions, {
            'number': bids[0].revision }, true)[0];

        var costs = trades_array[0].company_factors;

        if(lotRevision) {
            costs = lotRevision.company_factors;
        }

        var trade_array = [angular.copy($scope.my_trade)];
        trade_array[0].costs = costs;

        // bids[0].totals.hours_allowed = 0;
        // bids[0].totals.current_net_pay = 0;
        // bids[0].totals.labor = 0;

        _.each(lot_info.active_options, function(option) {
            var my_opt = $filter('filter')($scope.trade_options.options, {
                'number': option.number}, true)[0];

            var tradeInfo = $filter('filter')(option.totals, {
                'trade': $scope.user.trade[0] }, true)[0];

            if(tradeInfo) {
                var subtasks = $filter('filter')(my_opt.subtasks, {
                    'code': task.task_code, 'plan': task.plan_code}, true);
                subtasks = $filter('filter')(subtasks, {
                    'revision': tradeInfo.option_revision}, true);

                if(subtasks.length > 0) {
                    //var is_multiple = (tradeInfo.multiple > 1)?true: false;

                    var item = {
                        'revision': tradeInfo.option_revision,
                        'lot': task.lot, //lot number
                        'number': option.number, //option number
                        'phase': task.phase,
                        'is_multiple': (tradeInfo.multiple>1)?true:false,
                        'multiple': tradeInfo.multiple,
                    }

                    //apply the options to the bid task
                    new_bid_tasks = projectOptionService.findBidSubtasksForOptionUpdates(
                        item, lot_info, subtasks, bids, trade_array, tradeInfo.multiple);

                    //if we an update set as the bid task
                    if(new_bid_tasks.length > 0) {
                        bids = new_bid_tasks;
                    } 

                    //_.each(bids, function(item) {
                        // if(tradeInfo.multiple > 1)
                        //     $scope.applyBidTaskMultiple(bids[0], tradeInfo.multiple);
                    //});

                    changes_made = true;
                }
            } else {
                console.log('this might not be an error but we did not get trade totals.');
            }
        });

        return changes_made;
    };

    $scope.buildSpreadsheet = function() {
    	$scope.spreadsheets = [];
	    $scope.spreadsheets.phases = [];
	    $scope.spreadsheets.phases.lots = [];
        $scope.all_bid_tasks = [];

    	var my_tasks = [];
    	var phase_tasks = [];
    	var lot_tasks = [];
    	var ordered_tasks = [];
    	var temp_tasks = [];
    	var lot_numbers = [];
    	var lot_data = [];

        if($scope.selectedTrade.name === 'All') {
            if($scope.selectedPhase.name === 'All') {
                my_tasks = $scope.tasks;
            } else {
                my_tasks = $filter('filter')($scope.tasks, {'phase': $scope.selectedPhase.name});
            }
            if($scope.selectedLot.name !== 'All') {
                my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
            }
        } else {
            if($scope.selectedPhase.name === 'All') {
                my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name});
            } else {
                my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name, 'phase': $scope.selectedPhase.name});
            }

            if($scope.selectedLot.name !== 'All') {
                my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
            }
        }

    	_.each($scope.phases, function(phase) {
    		if(phase.name !== 'All') {
    			//get all of my tasks by the current phase
    			phase_tasks = $filter('filter')(my_tasks, {'phase': phase.name}, true);

    			lot_numbers = [];
    			//build a lot list
    			_.each(phase_tasks, function(task) {
	    			var in_var = $filter('filter')(lot_numbers, {'name': task.lot}, true);
	    			temp_tasks = [];

	    			if(in_var.length === 0) {
	    				lot_numbers.push({
	    					name: task.lot
	    				});
	    			}
	    		});

	    		lot_numbers = $filter('orderBy')(lot_numbers, ['name'], false);
    			//lot_numbers.forEach(function(lot_number) {
                _.each(lot_numbers, function(lot_number) {
    				lot_data = [];
    				var total_hours_allowed = 0;
    				var total_labor_costs = 0;
    				var actual_man_hours = 0;
    				var actual_labor_costs = 0;
    				var total_hours_saved = 0;
    				var total_labor_saved = 0;
                    var bid_material_total = 0;
                    var actual_material_total = 0;
                    var bid_equipment_total = 0;
                    var actual_equipment_total = 0;
                    var multiple = 1;
                    var option_lot = $filter('filter')($scope.selectedItem.lots, {
                        'phase': phase.name, 'number': lot_number.name }, true)[0];
                    var my_trade_options = [];

    				lot_tasks = $filter('filter')(phase_tasks, {'lot': lot_number.name}, true);
    				ordered_tasks = $filter('orderBy')(lot_tasks, ['job_code'], false);

                    //var bid_tasks = angular.copy($scope.bid_tasks);
                    var all_subtasks = [];
    				
                    _.each(ordered_tasks, function(task) {
                        var lot_bid_revision = $filter('filter')(option_lot.revisions, {'trade': task.trade}, true);

                        if(lot_bid_revision.length === 1) {
                            lot_bid_revision = lot_bid_revision[0].revision;
                        } else {
                            lot_bid_revision = 1;
                        }

                        var t_m = (task.plan_code === 'T&M')?true:false;
                        //only build the spreadsheets for bid trades
                        var is_tracked = $filter('filter')($scope.trades, {'name': task.trade}, true);
                        if(is_tracked.length === 0) return;

                        if(!task.project_bid_id && !t_m) {
                            toaster.pop('error', 'projectContractor, line 660',
                                'No projectBid for the task.  Contact admin.');
                        }

                        // if(!t_m) {
                        //     //the project lot contains the revision info for this
                        //     //task.  We have to get the bid and then the cost info
                        //     var bid_revision = $filter('filter')($scope.bid_tasks, {
                        //         '_id': task.project_bid_id }, true);

                        //     if(bid_revision.length !== 1) {
                        //         bid_revision = $filter('filter')($scope.bid_tasks, {
                        //             'lot': task.lot, 'phase': task.phase, 'task_code': task.task_code }, true);

                        //         if(bid_revision.length !== 1) {
                        //             toaster.pop('error', 'Error Getting ProjectBid',
                        //                 'Could not get the bid to the associated task. ' +
                        //                 'For lot/phase/task: ' + task.lot + '/' + task.phase +
                        //                 '/' + task.task_code + '. Might be an options issue.');
                        //         }
                        //     }
                        // }

                        var proj_trade = $filter('filter')($scope.selectedItem.trades,{
                            'name': task.trade }, true);

                        if(proj_trade.length !== 1) {
                            toaster.pop('error', 'projectContractor, line 698',
                                'Could not get the trade to the associated task.  Contact admin.');
                        }

                        var factors = {};
                        if(!t_m) {
                            if(lot_bid_revision === $scope.bid_revisions) {
                                factors = proj_trade[0].company_factors;
                            } else {
                                var factors_array = $filter('filter')(proj_trade[0].revisions, {
                                    'number': lot_bid_revision }, true);

                                if(factors_array.length !== 1) {
                                    toaster.pop('error', 'projectContractor, line 689',
                                        'Could not get the factors to the associated trade.  Contact admin.');
                                    factors = proj_trade[0].company_factors;
                                } else {
                                    factors = factors_array[0].company_factors;
                                }
                            }
                        } else {
                            factors = proj_trade[0].company_factors;
                        }

                        var bid = [];

                        if(!t_m) {
    	    				bid = $filter('filter')($scope.bid_tasks, {
                                'lot': task.lot, 'phase': task.phase, 'task_code': task.task_code }, true);

                            if(bid.length === 1) {
                                //this means there is an option applied to this bid task so use it

                            } else {
                                bid = $filter('filter')($scope.bid_tasks, {
                                    'plan_code': task.plan_code, 'task_code': task.task_code }, true);
        						
                                //remove bids if lot/phase is defined
                                _.remove(bid, function(item) {
                                    return item.lot && item.phase;
                                });

                                if(bid.length === 0) {
        							var new_bid = {
        								totals: {
        									hours_allowed: 0,
        									labor_cost: 0
        								}
        							}

        							bid.push(new_bid);

        						} else if(bid.length > 1) {
                                    //this means we have a revision to deal with so lets check what
                                    //revision this lot is set to for the tasks trade.
                                    let lot = $filter('filter')($scope.selectedItem.lots, {
                                        'number': task.lot, 'phase': task.phase }, true);
                                    if(lot.length !== 1) {
                                        toaster.pop('error', 'Could Not Find Lot', 'Could not find lot ' +
                                            task.phase + '/' + task.lot + '.  This should not happen.  Contact Admin.');
                                        return;
                                    } else {
                                        let tradeRev = $filter('filter')(lot[0].revisions, {'trade': task.trade}, true);
                                        if(tradeRev.length !== 1) {
                                            toaster.pop('error', 'Could Not Find Trade Revision', 'Could not find revision info for ' +
                                                task.phase + '/' + task.lot + '.  This should not happen.  Contact Admin.');
                                            return;
                                        } else {
                                            if(tradeRev[0].revision !== $scope.bid_revisions) {
                                                bid = $filter('filter')(bid, {'revision': tradeRev[0].revision}, true);
                                            } else {
                                                bid = $filter('filter')(bid, {'latest': true}, true);
                                                if(bid.length === 1) {
                                                    bid[0].revision = $scope.bid_revisions;
                                                } else {
                                                    console.log('we got problems');
                                                }
                                            }

                                            if(bid.length !== 1) {
                                                toaster.pop('error', 'Bid Trade Revision Error', 
                                                    'There is an issue finding the revision info for ' +
                                                    task.phase + '/' + task.lot + '.  This should not happen.  Contact Admin.');
                                                return;
                                            }
                                        }
                                    }
        						}
                            }
                        } else {
                            var new_bid = {
                                totals: {
                                    hours_allowed: 0,
                                    labor_cost: 0
                                }
                            }

                            bid.push(new_bid);
                        }

                        if(task.lot === '001' && task.task_code === '1301') {
                            console.log('im here');
                        }

                        if(task.lot === '002' && task.task_code === '1301') {
                            console.log('im here');
                        }

                        if(task.lot === '003' && task.task_code === '1301') {
                            console.log('im here');
                        }

                        if(bid[0].phase === '00') {
                            console.log(bid[0]);
                        }

                        var temp_bid = angular.copy(bid[0]);
                        temp_bid.lot = task.lot;
                        temp_bid.phase = task.phase;
                        $scope.all_bid_tasks.push(temp_bid);

                        var bid_total_hours_allowed = angular.copy(bid[0].totals.hours_allowed);
                        var bid_total_current_net_pay = angular.copy(bid[0].totals.current_net_pay);
                        var bid_total_labor = angular.copy(bid[0].totals.labor);
                        var bid_total_mark_up = angular.copy(bid[0].totals.mark_up);
                        var bid_general_liability = angular.copy(task.bid_general_liability);
                        var bid_subtasks = angular.copy(bid[0].subtasks);
                        var bid_materials = angular.copy(bid[0].materials);
                        var bid_equipment = angular.copy(bid[0].equipment);

			    		var code = task.task_code + ' - ' + task.task_name;

			    		var hours_saved = 0;
			    		var labor_saved = 0;

                        task.actual_direct_labor = angular.copy(task.actual_labor_costs);

			    		total_hours_allowed += bid_total_hours_allowed;
			    		total_labor_costs += bid_total_labor;
			    		actual_man_hours += task.actual_man_hours;
			    		//actual_labor_costs += task.actual_labor_costs;
			    		hours_saved = bid_total_hours_allowed - task.actual_man_hours;
			    		//labor_saved = bid_total_labor - task.actual_labor_costs;
			    		total_hours_saved += hours_saved;
			    		//total_labor_saved += labor_saved;

                        var task_completed = (task.status === 'finished')?true:false;

                        var start_date = moment(task.start_date);
                        var days = 0;
                        var warning_level = 0;

                        if(task_completed){
                            days = Math.round(moment.duration(moment(task.date_completed) - start_date).asDays());
                        } else {
                            days = Math.round(moment.duration(moment() - start_date).asDays());
                        }
                        if(days === 1)
                            warning_level = 1;
                        else if(days > 1)
                            warning_level = 2;

                        //compute actual side labor cost
                        // var workers_comp = 0;
                        // if(task.actual_labor_costs/task.actual_man_hours < factors.w_comp_break)
                        //   workers_comp = task.actual_labor_costs * factors.w_comp_high;
                        // else
                        //   workers_comp = task.actual_labor_costs * factors.w_comp_low;
                        var taxes = task.actual_labor_costs * factors.payroll_taxes;

                        var actual_material = 0;
                        var actual_equipment = 0;

                        if(task.materials.length) {
                            task.materials.forEach(function(add) {
                                if(add.manually_entered) {
                                    actual_material += add.total;
                                    actual_material_total += add.total;
                                } else if(add.submitted) {
                                    actual_material += add.total;
                                    actual_material_total += add.total;
                                }
                            });
                        }

                        if(task.equipment.length) {
                            task.equipment.forEach(function(add) {
                                if(add.submitted) {
                                    actual_equipment += add.total;
                                    actual_equipment_total += add.total;
                                }

                            });
                        }

                        //actual_material_total += actual_material;
                        //actual_equipment_total += actual_equipment;
                        //bid_material_total += bid[0].totals.materials;
                        //bid_equipment_total += bid[0].totals.equipment;

                        task.actual_labor_costs += task.actual_workers_comp + taxes;

                        var total_labor = (t_m)? 0:bid_total_labor;
                        labor_saved = total_labor - task.actual_labor_costs;
                        total_labor_saved += labor_saved;
                        actual_labor_costs += task.actual_labor_costs;

                        if(task.lot === '003' && task.task_code === '1301') {
                            console.log('im here');
                        }

			    		lot_data.push({
                            lot: task.lot,
                            code: code,
                            phase: task.phase,
                            plan_code: task.plan_code,
                            task_code: task.task_code,
                            hours_allowed: (t_m)? 0:bid_total_hours_allowed,
                            labor_cost: (t_m)? 0:bid_total_current_net_pay,
                            bid_labor_cost: (t_m)? 0:bid_total_labor,
                            bid_general_liability: bid_general_liability,
                            //bid_materials_cost: bid[0].totals.materials,
                            //bid_equipment_cost: bid[0].totals.equipment,
                            warning_level: warning_level,
                            scheduled_date: new Date(task.start_date),
                            actual_man_hours: task.actual_man_hours,
                            actual_labor_costs: task.actual_labor_costs, // + workers_comp + taxes,
                            actual_direct_labor: task.actual_direct_labor,
                            actual_workers_comp: task.actual_workers_comp,
                            markup: (t_m)? 0:bid_total_mark_up,
                            actual_material_costs: actual_material,
                            actual_equipment_costs: actual_equipment,
                            saved_man_hours: hours_saved,
                            saved_labor_costs: labor_saved,
                            notes: task.notes,
                            factors: factors,
                            completed: task_completed,
                            date_completed: (task_completed)? new Date(task.date_completed) : '',
                            tooltip_hours: task.tooltip,
                            trade: task.trade,
                            bid_materials: (t_m)? 0:bid_materials,
                            bid_equipment: (t_m)? 0:bid_equipment,
                            materials: task.materials,
                            equipment: task.equipment
                        });
	    			});

					temp_tasks.push({
						name: lot_number.name,
						data: lot_data,
						total_hours_allowed: total_hours_allowed,
	    				total_labor_costs: total_labor_costs,
	    				actual_man_hours: actual_man_hours,
	    				actual_labor_costs: actual_labor_costs,
	    				total_hours_saved: total_hours_saved,
	    				total_labor_saved: total_labor_saved,
                        bid_material_total: bid_material_total,
                        actual_material_total: actual_material_total,
                        bid_equipment_total: bid_equipment_total,
                        actual_equipment_total: actual_equipment_total
					});
    			});

				$scope.spreadsheets.phases.push({
		    		name: phase.name,
		    		lots: temp_tasks
		    	});
    		}
    	});

        //$scope.buildSummaryTable();

		console.log('finished task build' + $scope.spreadsheets);
    };

    $scope.changeProject = function() {
        $scope.trades = [];

        Projects.query({'_id': this.selectedProject._id }
            , function(projects) {
            $scope.selectedItem = projects[0];

            if($scope.selectedItem) {
                $scope.trades.push({
                    name: 'All'
                });

                $scope.selectedItem.trades.forEach(function(trade) {
                    $scope.trades.push({
                        name: trade.name
                    });
                });

                $scope.selectedTrade = $scope.trades[0];
            }

            $scope.buildTasks($scope.selectedItem);
            // $scope.buildSummaryTable();
            // $scope.buildLineChart();
            // $scope.buildJobCostingTable();
        });
    };

    $scope.getMultipleValue = function(option) {
        var val = $filter('filter')(option.totals, {'trade': $scope.user.trade[0]}, true)[0]
        return (val) ? val.multiple : 'N/A';
    };

    $scope.viewMaterialDetails = function(item) {
        $scope.material_detail_total = 0;
        _.each(item.materials, function(mat) {
            $scope.material_detail_total += mat.total;
        });
        $scope.material_details = item.materials;
    };

    $scope.buildTasks = function(project) {
        if(!project) return;

        $scope.phases = [];
        $scope.job_summary_phases = [];
        $scope.lots = [];

        if(project.trades.length !== 1) {
            toaster.pop('error', 'buildTasks', 'this is unexpected!  Contact admin');
            return;
        }

        ProjectHours.query({'project_id': project._id, 
            'trade': $scope.user.trade[0] }, function(project_hours) {
            ProjectMaterials.query({'project_id': project._id,
                'submitted': true,
                'trade': $scope.user.trade[0] }, function(project_materials) {
                _.each(project_materials, function(report) {
                    report.project_id = {
                        trade_code: project.trade_code, 
                        company_code: project.company_code,
                        job_code: project.job_code
                    }
                    report.invoice_date = moment(report.invoice_date).format('MMM D, YYYY');

                    report.material_detail_total = 0;
                    _.each(report.materials, function(mat) {
                        report.material_detail_total += mat.total;
                    });

                    //if the difference is less than a penny then don't worry about it
                    if(Math.abs(report.invoice_total - report.material_detail_total) < 0.02) {
                        report.material_detail_total = report.invoice_total;
                    }
                });

                $scope.all_project_materials = project_materials;
                var data = project_materials;
                //console.log(JSON.stringify(data))
                $scope.tableListMaterialParams = new NgTableParams({ count: 50 }, { dataset: data });
                ProjectEquipments.query({'project_id': project._id, 
                    'submitted': true,
                    'trade': $scope.user.trade[0] }, function(project_equipment) {
                    ProjectTasks.query({'project_id': project._id, 
                        'trade': $scope.user.trade[0] }, function (tasks) {
                        $scope.tasks = tasks;
                        $scope.project_hours = project_hours;
                        ProjectBids.query({'project_id': project._id, 
                            'trade': $scope.user.trade[0] }, function(bid_tasks) {

                            var bid_rev = $filter('unique')(bid_tasks, 'revision');
                            $scope.bid_revisions = bid_rev.length;
                            // $scope.bid_revisions = 1;
                            // _.each(bid_rev, function(bid) {
                            //     if(bid.revision > $scope.bid_revisions) {
                            //         $scope.bid_revisions = bid.revision;
                            //     }
                            // });
                            // $scope.bid_revisions += 1; //add one for latest

                            var latest_bids = $filter('filter')(bid_tasks, {'latest': true}, true);
                            if(latest_bids.length === 0) {
                                toaster.pop('error', 'Project Bids Revision Error', 
                                    'Project Bids have a revision issue. To correct please go to Bid Control Center.  Click the Review button.  In the review mode, click the Regenerate button to refresh the bids associated with this project.');
                                return;
                            } else {
                                $scope.bid_tasks = bid_tasks;
                            }

                            Options.query({'project_id': project._id }, function(options) {
                                $scope.trade_options = {};
                                if(options.length === 0) {
                                    console.log('no options for this project');
                                } else if(options.length === 1) {
                                    $scope.trade_options = options[0];
                                } else {
                                    toaster.pop('error', 'Options Error', 
                                        'Multiple options for this project. Contact Admin');
                                    return;
                                }
                            
                                Extras.query({'project_id': project._id, 
                                    'trade_id': $scope.my_trade._id,
                                    'trade': $scope.user.trade[0]}, function(extras) {
                                    $scope.extras = extras;
                                    var today = moment();

                                    _.each($scope.tasks, function(task) {
                                        var task_hours = $filter('filter')(project_hours, {
                                            'project_task_id': task._id}, true);
                                        var in_var = $filter('filter')($scope.phases, { 
                                            'name': task.phase}, true);
                                        var in_lot = $filter('filter')($scope.lots, { 
                                            'name': task.lot}, true);

                                        var task_materials = $filter('filter')(project_materials,
                                                    { 'phase': task.phase , 'task_code': task.task_code}, true);
                                        var task_equipment = $filter('filter')(project_equipment,
                                                    { 'phase': task.phase , 'task_code': task.task_code}, true);

                                        // var option_lot = $filter('filter')($scope.selectedItem.lots, {
                                        //     'phase': task.phase, 'number': task.lot }, true)[0];
                                        // var lot_bid_revision = $filter('filter')(option_lot.revisions, {
                                        //     'trade': task.trade}, true);

                                        // if(lot_bid_revision.length === 1) {
                                        //     lot_bid_revision = lot_bid_revision[0].revision;
                                        // } else {
                                        //     lot_bid_revision = 1;
                                        // }

                                        task.materials = [];
                                        task.equipment = [];

                                        task.actual_material_costs = 0;
                                        task.actual_equipment_costs = 0;

                                        _.each(task_materials, function(material) {
                                            if(!moment(material.invoice_date).isAfter(today)) {
                                                var mat = $filter('filter')(material.materials, {
                                                    'lot': task.lot}, true);

                                                _.each(mat, function(curr_mat) {
                                                    task.actual_material_costs += curr_mat.total;
                                                    curr_mat.submitted = material.submitted;
                                                    curr_mat.manually_entered = material.manually_entered;
                                                    task.materials.push(angular.copy(curr_mat));
                                                });
                                            } else {
                                                console.log('not including material due to date issue');
                                                console.log(material);
                                            }
                                        });

                                        //task_equipment.forEach(function(equipment) {
                                        _.each(task_equipment, function(equipment) {
                                            if(!moment(equipment.invoice_date).isAfter(today)) {
                                                var eq = $filter('filter')(equipment.equipment, {'lot': task.lot}, true);

                                                //eq.forEach(function(curr_eq) {
                                                _.each(eq, function(curr_eq) {
                                                   task.actual_equipment_costs += curr_eq.total;
                                                   curr_eq.submitted = equipment.submitted;
                                                   curr_eq.manually_entered = equipment.manually_entered;
                                                   task.equipment.push(angular.copy(curr_eq));
                                                });
                                            }
                                        });


                                        if(task.plan_code === 'T&M') {
                                            console.log('this is a t&m task...no bid data');
                                        } else {
                                            var bid_revision = projectBidService.getProjectBidForTask(
                                                task, $scope.bid_tasks, $scope.selectedItem.lots, $scope.bid_revisions);
                                        }

                                        var proj_trade = $filter('filter')($scope.selectedItem.trades,{
                                            'name': task.trade }, true);

                                        if(proj_trade.length !== 1) {
                                            toaster.pop('error', 'projectContractor, line 916',
                                                'Could not get the trade to the associated task.  Contact admin.');
                                        }

                                        var factors = {};
                                        var found = false;

                                        if(task.plan_code !== 'T&M') {
                                            if(!bid_revision[0]) {
                                                factors = proj_trade[0].company_factors;
                                            } else if(bid_revision[0].latest) {
                                                factors = proj_trade[0].company_factors;
                                                found = true;
                                            } else {
                                                var factors_array = $filter('filter')(proj_trade[0].revisions, {
                                                    'number': bid_revision[0].revision }, true);

                                                if(factors_array.length !== 1) {
                                                    toaster.pop('error', 'Bid Revisions Not Matching.',
                                                        task.phase + '/' + task.lot + '/' + task.task_code +
                                                        ' is not matching up due to a revision issue.  Looking for rev ' +
                                                        bid_revision[0].revision + '.  Setting factors to current.');
                                                    factors = proj_trade[0].company_factors;
                                                } else {
                                                    factors = factors_array[0].company_factors;
                                                }
                                            } 
                                        } else {
                                            factors = proj_trade[0].company_factors;
                                        }

                                        $scope.factors = factors;

                                        task.tooltip = [];
                                        task.actual_man_hours = 0;
                                        task.actual_labor_costs = 0;
                                        task.actual_workers_comp = 0;

                                        if(found) {
                                            task.bid_general_liability = bid_revision[0].totals.general_liability;
                                            task.bid_mark_up = bid_revision[0].totals.mark_up;
                                        }

                                        _.each(task_hours, function(hours) {
                                            var act_work_comp = 0;
                                            
                                            task.actual_workers_comp += costTotalService.getWorkersComp(hours, factors);
                                            task.actual_man_hours += hours.hours;
                                            task.actual_labor_costs += hours.pay_total;
                                            task.tooltip.push({
                                                name: hours.name,
                                                username: hours.username,
                                                rate: hours.rate,
                                                hours: hours.hours,
                                                over: hours.hours_over_time,
                                                double: hours.hours_double_time,
                                                payroll_taxes: factors.payroll_taxes,
                                                production_bonus: hours.production_bonus,
                                                use: (hours.rate < factors.w_comp_break) ? 'H' : 'L',
                                                w_comp: (hours.rate < factors.w_comp_break) ? factors.w_comp_high : factors.w_comp_low,
                                                pay_total: hours.pay_total,
                                                date: new Date(hours.date)
                                            });
                                        });

                                        if(in_lot.length === 0) {
                                            $scope.lots.push({
                                                name: task.lot
                                            });
                                        }

                                        if(in_var.length === 0) {
                                            $scope.phases.push({
                                                name: task.phase
                                            });
                                        }
                                    });
                                    $scope.phases = $filter('orderBy')($scope.phases, ['name'], false);
                                    $scope.lots = $filter('orderBy')($scope.lots, ['name'], false);

                                    $scope.job_summary_phases = angular.copy($scope.phases);

                                    $scope.phases.unshift({
                                        name: 'All'
                                    });

                                    $scope.lots.unshift({
                                        name: 'All'
                                    });

                                    $scope.selectedPhase = $scope.phases[0];
                                    $scope.selectedLot = $scope.lots[0];

                                    $scope.buildSpreadsheet();
                                    $scope.buildDoughnutChart();
                                    //$scope.buildSpreadsheet();
                                    $scope.buildSummaryTable();
                                    $scope.buildLineChart();
                                    $scope.buildJobCostingTable();
                                });
                            });
                        });
                    });
                });
            });
        });
    };

    function roundToTwo(num) {    
        return +(Math.round(num + "e+2")  + "e-2");
    }

    $scope.buildJobCostingTable = function() {
        //if(!$scope.selectedPhase) return;

        var my_extras = [];
        var my_tasks = [];
        $scope.jobCostingLots = [];
        //if($scope.selectedTrade.name === 'All') {
            if($scope.selectedPhase.name === 'All') {
                my_extras = $scope.extras;
                my_tasks = $scope.tasks;
                $scope.jobCostingLots = $scope.selectedItem.lots;
            } else {
                my_extras = $filter('filter')($scope.extras, {
                    'phase': $scope.selectedPhase.name}, true);
                my_tasks = $filter('filter')($scope.tasks, {
                    'phase': $scope.selectedPhase.name}, true);
                $scope.jobCostingLots = $filter('filter')($scope.selectedItem.lots, {
                    'phase': $scope.selectedPhase.name}, true);
            }

            if($scope.selectedLot.name !== 'All') {
                my_extras = $filter('filter')(my_extras, {
                    'lot': $scope.selectedLot.name}, true);
                my_tasks = $filter('filter')(my_tasks, {
                    'lot': $scope.selectedLot.name}, true);
                $scope.jobCostingLots = $filter('filter')($scope.selectedItem.lots, {
                    'number': $scope.selectedLot.name}, true);
            }

        // } else {
        //     if($scope.selectedPhase.name === 'All') {
        //         my_extras = $filter('filter')($scope.extras, {'trade': $scope.selectedTrade.name});
        //     } else {
        //         my_extras = $filter('filter')($scope.extras, {'trade': $scope.selectedTrade.name, 'phase': $scope.selectedPhase.name});
        //     }

        //     if($scope.selectedLot.name !== 'All') {
        //         my_extras = $filter('filter')(my_extras, {'lot': $scope.selectedLot.name});
        //     }
        // }

        $scope.jobCostingLots = $filter('orderBy')($scope.jobCostingLots, 'number');
        //build contract totals per lot
        $scope.contract_total = 0;
        $scope.options_total = 0;
        $scope.extras_total = 0;
        $scope.contract_complete_total = 0;
        $scope.options_complete_total = 0;
        $scope.extras_complete_total = 0;
        $scope.job_costing_complete_total = 0;
        $scope.contract_complete_list = [];
        $scope.cost_details_list = [];
        $scope.cost_complete_total = 0;

        _.each($scope.jobCostingLots, function(lot) {
            lot.extras = [];
            lot.extras = $filter('filter')(my_extras, {
                'phase': lot.phase, 'lot': lot.number});
            lot.extras_total = 0;

            _.each(lot.extras, function(extra) {
                lot.extras_total += extra.total;
                $scope.extras_total += extra.total;
            });

            lot.contract_total = 0;
            var plan_lot = $filter('filter')($scope.selectedItem.plan_codes, {'item': lot.plan}, true);
            if(plan_lot.length !== 1) {
                toaster.pop('warning', 'Need To Update Totals', 'Go to bid review and update plan totals');
            } else {
                //get the revision for my trade
                var lot_rev = $filter('filter')(lot.revisions, {'trade': $scope.user.trade[0]}, true);
                if(lot_rev.length !== 1) {
                    toaster.pop('warning', 'Problem Getting Lot Revision', 
                        'Setting to revision one for lot ' + lot.number + 
                        '. To correct, set the revision for lot ' + lot.number +
                        ' in Project Information.');
                    lot_rev = [];
                    lot_rev.push({
                        trade: $scope.user.trade[0],
                        revision: 1
                    });
                }
                var revision = $filter('filter')(plan_lot[0].trade_totals, {
                    'trade': $scope.user.trade[0], 'revision': lot_rev[0].revision }, true);

                if(revision.length !== 1) {
                    if(lot.plan !== 'T&M') {
                        //this case covers if the revision is off
                        if(revision.length === 0) {
                            //plan_totals and lot revisions are out of sync
                            var lot = $filter('filter')($scope.selectedItem.lots, {
                                'phase': lot.phase,
                                'number': lot.number}, true);

                            if(lot.length !== 1) {
                                toaster.pop('error', 'Problem Getting Lot',
                                    'contact admin');
                            } else {
                                var rev = $filter('filter')(lot[0].revisions, {
                                    'trade': $scope.user.trade[0]}, true);
                                if(rev.length !== 1) {
                                    toaster.pop('error', 'Problem Getting Lot Revision',
                                        'contact admin');
                                } else {
                                    if(rev[0].revision === plan_lot[0].trade_totals.length + 1) {
                                        //update revision number
                                        rev[0].revision = plan_lot[0].trade_totals.length;
                                        revision.push(plan_lot[0].trade_totals[plan_lot[0].trade_totals.length-1]);
                                        $scope.selectedItem.$update();
                                    }
                                }
                            }
                        } else {
                            toaster.pop('warning', 'Problem Getting Revision Total',
                                'Go to bid review and update plan totals');
                        }
                    }
                }
                
                if(revision.length !== 0 && revision[0].total != null) {
                    lot.contract_total = revision[0].total;
                } else if(plan_lot[0].item !== 'T&M') {
                    toaster.pop('warning', 'Need To Update Totals', 'Go to bid review and update plan totals');
                }
            }

            $scope.contract_total += lot.contract_total;
            lot.options_total = 0;
            _.each(lot.active_options, function(active_option) {
                var cost = $filter('filter')(active_option.totals, {
                    'trade': $scope.user.trade[0] }, true)[0];

                active_option.cost = (cost) ? cost.total : 0;

                if(!active_option.cost) active_option.cost = 0;
                lot.options_total += active_option.cost;
            });

            $scope.options_total += lot.options_total;
            var inlist = $filter('filter')($scope.contract_complete_list, { 
                'phase': lot.phase }, true);
            if(inlist.length === 0) {
                $scope.contract_complete_list.push({
                    'phase': lot.phase,
                    'contract_total': lot.contract_total,
                    'options_total': lot.options_total,
                    'extras_total': lot.extras_total,
                    'total': lot.contract_total + lot.options_total + lot.extras_total,
                    'costs': 0
                });
            } else if(inlist.length === 1) {
                inlist[0].contract_total += lot.contract_total;
                inlist[0].options_total += lot.options_total;
                inlist[0].extras_total += lot.extras_total;
                inlist[0].total += lot.contract_total + lot.options_total + lot.extras_total;
                //inlist[0].costs += 0;
            }

            if(lot.complete) {
                $scope.contract_complete_total += lot.contract_total;
                $scope.options_complete_total += lot.options_total;
                $scope.extras_complete_total += lot.extras_total;
                $scope.job_costing_complete_total += lot.contract_total +
                    lot.options_total + lot.extras_total;
            }
        });

        $scope.costDetails.hours = 0;
        $scope.costDetails.average_hourly_pay = 0;
        $scope.costDetails.direct_labor = 0;
        $scope.costDetails.payroll_taxes = 0;
        $scope.costDetails.workers_comp = 0;
        $scope.costDetails.labor = 0; //dir_lab+taxes+work_comp
        $scope.costDetails.materials = 0;
        $scope.costDetails.equipment = 0;
        $scope.costDetails.general_liability = 0;
        $scope.costDetails.completed_hours = 0;
        $scope.costDetails.completed_direct_labor = 0;
        $scope.costDetails.completed_average_hourly_pay = 0;
        $scope.costDetails.completed_payroll_taxes = 0;
        $scope.costDetails.completed_workers_comp = 0;
        $scope.costDetails.completed_labor = 0;
        $scope.costDetails.completed_materials = 0;
        $scope.costDetails.completed_equipment = 0;
        $scope.costDetails.completed_general_liability = 0;

        $scope.cost_total = 0;
        //$scope.cost_complete_total = 0;
        var extra_costs = [];
        //var bid_hours = 0;
        _.each(my_tasks, function(task) {
            if(!task.actual_material_costs) task.actual_material_costs = 0;
            if(!task.actual_equipment_costs) task.actual_equipment_costs = 0;
            if(!task.actual_labor_costs) task.actual_labor_costs = 0;
            if(!task.actual_direct_labor) task.actual_direct_labor = 0;

            $scope.costDetails.hours += task.actual_man_hours;
            $scope.costDetails.direct_labor += task.actual_direct_labor;
            var avg_pay = 0;
            var taxes = 0;
            var workers_comp = 0;
            if(task.actual_direct_labor) {
                var taxes = task.actual_direct_labor * $scope.factors.payroll_taxes;
                $scope.costDetails.payroll_taxes += taxes;

                $scope.costDetails.workers_comp += task.actual_workers_comp;
                $scope.costDetails.labor += task.actual_direct_labor + 
                    taxes + task.actual_workers_comp;
            }

            $scope.costDetails.materials += task.actual_material_costs;
            $scope.costDetails.equipment += task.actual_equipment_costs;

            var inlist = $filter('filter')($scope.cost_details_list, { 
                'phase': task.phase }, true);

            var more_costs = $filter('filter')($scope.contract_complete_list, {
                'phase': task.phase }, true);

            var genLib = 0;

            if(more_costs.length === 1 && extra_costs.indexOf(task.phase) === -1) {
                genLib = (more_costs[0].extras_total +
                    + more_costs[0].contract_total + more_costs[0].options_total) * 
                    $scope.factors.general_liability;
                extra_costs.push(task.phase);
            } 

            if(inlist.length === 0) {
                $scope.cost_details_list.push({
                    'phase': task.phase,
                    'hours': task.actual_man_hours,
                    'average_hourly_pay': task.actual_man_hours?task.actual_direct_labor / task.actual_man_hours:0,
                    'direct_labor': task.actual_direct_labor,
                    'payroll_taxes': taxes,
                    'workers_comp': task.actual_workers_comp,
                    'labor': task.actual_direct_labor + taxes + task.actual_workers_comp,
                    'materials': task.actual_material_costs,
                    'equipment': task.actual_equipment_costs,
                    'general_liability': genLib,
                });
            } else if(inlist.length === 1) {
                inlist[0].hours += task.actual_man_hours;
                inlist[0].average_hourly_pay += task.actual_man_hours?task.actual_direct_labor / task.actual_man_hours:0;
                inlist[0].direct_labor += task.actual_direct_labor;
                inlist[0].payroll_taxes += taxes;
                inlist[0].workers_comp += task.actual_workers_comp;
                inlist[0].labor += task.actual_direct_labor + taxes + task.actual_workers_comp;
                inlist[0].materials += task.actual_material_costs;
                inlist[0].equipment += task.actual_equipment_costs;
                inlist[0].general_liability += genLib;
            }

            if(task.status === 'finished') {
                $scope.costDetails.completed_hours += task.actual_man_hours;
                $scope.costDetails.completed_direct_labor += task.actual_direct_labor;
                $scope.costDetails.completed_payroll_taxes += taxes;
                $scope.costDetails.completed_workers_comp += task.actual_workers_comp;
                $scope.costDetails.completed_labor += task.actual_direct_labor + 
                    taxes + task.actual_workers_comp;
                $scope.costDetails.completed_materials += task.actual_material_costs;
                $scope.costDetails.completed_equipment += task.actual_equipment_costs;
                $scope.costDetails.completed_average_hourly_pay = 
                    task.actual_direct_labor / task.actual_man_hours;

                // var compGenLib = (task.actual_labor_costs + task.actual_material_costs +
                //         task.actual_equipment_costs + task.actual_workers_comp) * $scope.factors.general_liability;

                $scope.cost_complete_total += task.actual_labor_costs + task.actual_material_costs +
                    task.actual_equipment_costs + genLib;
            }

            var inlist = $filter('filter')($scope.contract_complete_list, {'phase': task.phase}, true);

            if(inlist.length === 1) {
                //var genLib = 0//(task.actual_labor_costs + task.actual_material_costs +
                        //task.actual_equipment_costs + task.actual_workers_comp) * $scope.factors.general_liability;
                
                inlist[0].costs += task.actual_labor_costs + task.actual_material_costs +
                    task.actual_equipment_costs + genLib;

                task.computed_general_liability = genLib;
            }
        });

        var full_total = $scope.contract_total +
            $scope.options_total + $scope.extras_total;

        $scope.costDetails.general_liability = 
            full_total * $scope.factors.general_liability;

        var full_complete_total = $scope.contract_complete_total +
            $scope.options_complete_total + $scope.extras_complete_total;

        $scope.costDetails.completed_general_liability = 
            full_complete_total * $scope.factors.general_liability;
        $scope.cost_total = $scope.costDetails.labor + $scope.costDetails.materials +
            $scope.costDetails.equipment + $scope.costDetails.general_liability;

        $scope.costDetails.average_hourly_pay = 
            $scope.costDetails.direct_labor / $scope.costDetails.hours;

        $scope.job_costing_total = full_total;
    };

    $scope.contractComplete = function(phase) {
        var item = $filter('filter')($scope.contract_complete_list, {
            'phase': phase}, true)[0];

        return (item)?item.contract_total:0;
    }

    $scope.optionsComplete = function(phase) {
        var item = $filter('filter')($scope.contract_complete_list, {
            'phase': phase}, true)[0];

        return (item)?item.options_total:0;
    }

    $scope.extrasComplete = function(phase) {
        var item = $filter('filter')($scope.contract_complete_list, {
            'phase': phase}, true)[0];

        return (item)?item.extras_total:0;
    }

    $scope.totalComplete = function(phase) {
        var item = $filter('filter')($scope.contract_complete_list, {
            'phase': phase}, true)[0];

        return (item)?item.total:0;
    }

    $scope.costsComplete = function(phase) {
        var item = $filter('filter')($scope.contract_complete_list, {
            'phase': phase}, true)[0];

        return (item)?item.costs:0;
    }

    $scope.hoursDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.hours:0;
    }

    $scope.avgHoursDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.average_hourly_pay:0;
    }

    $scope.directLaborDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.direct_labor:0;
    }

    $scope.payrollTaxesDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.payroll_taxes:0;
    }

    $scope.workCompDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.workers_comp:0;
    }

    $scope.laborDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.labor:0;
    }

    $scope.materialDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.materials:0;
    }

    $scope.equipmentDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.equipment:0;
    }

    $scope.genLibDetail = function(phase) {
        var item = $filter('filter')($scope.cost_details_list, {
            'phase': phase}, true)[0];

        return (item)?item.general_liability:0;
    }

    $scope.grossProfitDetail = function(phase) {
        var item = $filter('filter')($scope.contract_complete_list, {
            'phase': phase}, true)[0];

        return (item)?item.total - item.costs:0;
    }

    $scope.init = function() {
        console.log('in the contractor init function');
    	if(!MeanUser.user.username) return;

        _.each(MeanUser.user.roles, function(role) {
            if(role === 'admin') {
                $scope.is_admin = true;
            } else if(role === 'tm_admin') {
                $scope.is_admin = true;
            } else if(role === 'tm_office') {
                $scope.is_admin = true;
            } else if(role === 'tm') {
                $scope.is_manager = true;
            }
        });

        $scope.is_builder = builderService.isBuilder($scope.user.username);

    	$scope.bid_hours_data = [0,0,0,0,1];

        userService.getMainAccountId($scope.user.username).then(function(id) {
            contactService.getMyContacts(id).then(function(contacts) {
                $scope.builders = [];

                Trades.query({'main_account_id': id}, function(trade) {
                    if(trade.length !== 1) return;

                    $scope.my_trade = trade[0]

                    trade[0].company_code =
                        aceUtils.padDigits(trade[0].company_code, 3);
                    trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                    $scope.builders.push(trade[0]);
                });

                contacts.builders.forEach(function(builder) {
                    Builders.query({'builder': builder._id}, function(builders) {
                        if(builders.length === 0) return;
                        builders[0].company_code =
                            aceUtils.padDigits(builders[0].company_code, 3);
                        builders[0].trade_code = '00';
                        $scope.builders.push(builders[0]);
                    });
                });
            });
        });
	};
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectContractor.js